import { initVueApp } from '../lib/utils/vue3compat/init_vue_app.js?vue3';
import apolloProvider from './graphql.js?vue3';
import LastCommit from './components/last_commit.vue?vue3';
import repositoryPathMixin from '~/repository/mixins/repository_path';
import { generateHistoryUrl } from '~/repository/utils/url_utility';

export default function initLastCommitApp(router) {
  const lastCommitEl = document.getElementById('js-last-commit');
  if (!lastCommitEl) return null;

  return initVueApp({
    el: lastCommitEl,
    name: 'LastCommitRoot',
    router,
    apolloProvider,
    component: {
      name: 'LastCommitApp',
      mixins: [repositoryPathMixin],
      computed: {
        refType() {
          return this.$route.meta.refType || this.$route.query.ref_type;
        },
        historyUrl() {
          return generateHistoryUrl(
            lastCommitEl.dataset.historyLink,
            this.computedPath,
            this.refType,
          );
        },
      },
      render(h) {
        return h(LastCommit, {
          props: {
            currentPath: this.computedPath,
            refType: this.refType,
            historyUrl: this.historyUrl.href,
          },
        });
      },
    },
  });
}
